import throttle from 'lodash.throttle';
import { ClientEvent } from '../../../enums';

export const GridScrollPositionType = {
  PinnedToLeft: 'pinned-to-left',
  PinnedToRight: 'pinned-to-right',
  NotPinned: 'not-pinned',
  Hidden: 'hidden',
};

const GridScrollPosition = {
  data() {
    return {
      element: null,
      scrollPosition: GridScrollPositionType.Hidden,
    };
  },
  methods: {
    addScrollEventListener(element) {
      this.element = element;

      this.setScrollPosition();

      this.element.addEventListener(ClientEvent.Scroll, this.handleScroll);
    },
    removeScrollEventListener() {
      this.element.removeEventListener(ClientEvent.Scroll, this.handleScroll);
    },
    getHasScroll() {
      return this.element.scrollWidth > this.element.clientWidth;
    },
    setScrollPosition() {
      const newScrollPosition = this.getScrollPosition();

      if (newScrollPosition === this.scrollPosition) {
        return;
      }

      this.scrollPosition = newScrollPosition;
    },
    getScrollPosition() {
      const {
        scrollLeft,
        offsetWidth,
        scrollWidth,
      } = this.element;

      if (!this.getHasScroll()) {
        return GridScrollPositionType.Hidden;
      }

      const isPinnedToTheLeft = scrollLeft <= 0;

      if (isPinnedToTheLeft) {
        return GridScrollPositionType.PinnedToLeft;
      }

      const maxScrollLeft = scrollWidth - offsetWidth;
      const isPinnedToRight = scrollLeft >= maxScrollLeft;

      if (isPinnedToRight) {
        return GridScrollPositionType.PinnedToRight;
      }

      return GridScrollPositionType.NotPinned;
    },
    // eslint-disable-next-line prefer-arrow-callback, func-names
    handleScroll: throttle(function () {
      if (this.getHasScroll()) {
        this.setScrollPosition();
      }
    }, 100),
  },
};

export default GridScrollPosition;
